import { useQuery } from "@tanstack/react-query";
import { getDotdigitalMappings } from "../../api/bDotdigitalApi";

export const useGetDotdigitalMappings = (organisationId) => {
  return useQuery({
    queryKey: ["dotdigital-mappings", organisationId],
    queryFn: () => getDotdigitalMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000,
    onError: (error) => {
      console.error("Error fetching Dotdigital mappings:", error.response || error);
    },
  });
};
